import { render, staticRenderFns } from "./default-without-header.vue?vue&type=template&id=282a4618"
import script from "./default-without-header.vue?vue&type=script&lang=js"
export * from "./default-without-header.vue?vue&type=script&lang=js"
import style0 from "./default-without-header.vue?vue&type=style&index=0&id=282a4618&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sidebar: require('/Users/armandheijder/Documents/Development/EW/Frontend/components/Sidebar.vue').default})
